<template>
	<b-container class="user-profile-container" v-if="user != null && loaded">
		<b-row v-if="!canEditUser()">
			<b-col>
				<b-row>
					<b-col lg="4">
						<div class="lcr-summary__label">User</div>
						<div class="lcr-summary__value">{{user.firstName.value}} {{user.lastName.value}}</div>
						<div class="lcr-summary__value">{{user.title.value}}</div>
						<div class="lcr-summary__value" :v-html="getFlatTree(user.organizationId.value)"></div>
						<div class="lcr-summary__value" v-show="user.email.value"><a :href="Format.hrefEmail(user.email.value)">{{user.email.value}}</a></div>
						<div class="lcr-summary__value" v-show="user.phone.value"><a :href="Format.hrefPhone(user.phone.value)">{{user.phone.value}}</a></div>
						<div class="lcr-summary__value" v-show="user.altPhone.value"><a :href="Format.hrefPhone(user.altPhone.value)">{{user.altPhone.value}}</a></div>

						<div class="lcr-summary__label mt-3">Lane Closures Role</div>
						<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[0].id)"><span>{{User.getRoleOptions[0].name}}</span></div>
						<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[1].id)"><span>{{User.getRoleOptions[1].name}}</span></div>
						<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[2].id)"><span>{{User.getRoleOptions[2].name}}</span></div>
						<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[3].id)"><span>{{User.getRoleOptions[3].name}}</span></div>
						<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[4].id)"><span>{{User.getRoleOptions[4].name}}</span></div>
						<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[5].id)"><span>{{User.getRoleOptions[5].name}}</span></div>
						<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[6].id)"><span>{{User.getRoleOptions[6].name}}</span></div>

					</b-col>
					<b-col lg="4" class="mt-3">
						<div v-if="supervisor" class="contact">
							<div class="lcr-summary__label">Supervisor</div>
							<div class="contact__name">{{supervisor.firstName}} {{supervisor.lastName}}</div>
							<div class="contact__organization">{{supervisor.organizationName}}</div>
							<div class="contact_email" v-show="supervisor.email"><a :href="Format.hrefEmail(supervisor.email)">{{supervisor.email}}</a></div>
							<div class="contact__phone" v-show="supervisor.phone"><a :href="Format.hrefPhone(supervisor.phone)">{{supervisor.phone}}</a></div>
							<div class="contact__phone" v-show="supervisor.altPhone"><a :href="Format.hrefPhone(supervisor.altPhone)">{{supervisor.altPhone}}</a></div>
						</div>

						<div v-if="alternateContact" class="contact">
							<div class="lcr-summary__label">Alternate Contact</div>
							<div class="contact__name">{{alternateContact.firstName}} {{alternateContact.lastName}}</div>
							<div class="contact__organization">{{alternateContact.organizationName}}</div>
							<div class="contact_email" v-show="alternateContact.email"><a :href="Format.hrefEmail(alternateContact.email)">{{alternateContact.email}}</a></div>
							<div class="contact__phone" v-show="alternateContact.phone"><a :href="Format.hrefPhone(alternateContact.phone)">{{alternateContact.phone}}</a></div>
							<div class="contact__phone" v-show="alternateContact.altPhone"><a :href="Format.hrefPhone(alternateContact.altPhone)">{{alternateContact.altPhone}}</a></div>
						</div>

					</b-col>
				</b-row>

			</b-col>
		</b-row>


		<b-form @submit="onSubmit" @reset="onReset"  v-if="canEditUser()">

			<h1 class="page-title">Account</h1>
			<b-row>
				<b-col>
					<b-form-group label="Organization or Group"
					:state="user.organizationId.status"
					:invalid-feedback="user.organizationId.invalidMessage"
					>
					<vue-select-grouped v-model="user.organizationId.value" :canDelete="false"  :options="organizations" label="name" :reduce="name => name.id" @input="setOrganization" :disabled="true">
						<template v-slot:option="optionGroup" :option="(typeof option === 'object')?option:{[name]: option, namePath:option.namePath, name:option.name, groupName:option.groupName}">
						</template>
						<template v-slot:option="option">
							<span :class="getLevelClassName(option.level)">{{ option.name }}</span>
						</template>
						<template v-slot:selected-option-container="option" :option="(typeof option === 'object')?option:{[name]: option, namePath:option.namePath, name:option.name}">
							<div class="vs__selected-options" v-html="getFlatTree(option.option)"></div>
						</template>
					</vue-select-grouped>
				</b-form-group>
			</b-col>
		</b-row>

			<b-row v-show="false">
				<b-col lg="4">
					<b-form-group label="Show Requests default filter"
					:state="user.showMine.status"
					:invalid-feedback="user.showMine.invalidMessage"
					>
					<p>Set the default Show Request filter in request listings.</p>
					<b-form-select id="input-show-mine" v-model="user.showMine.value" @input="user.showMine.resetStatus()" :state="user.showMine.status" :options="User.getShowMineOptions" value-field="id" text-field="name" inline></b-form-select>
				</b-form-group>
			</b-col>
		</b-row>
		<b-row>
			<b-col lg="4">

				<b-form-group label="Username"
				@click="focusUsernameField"
				:state="usernamePrefix.status"
				:invalid-feedback="usernamePrefix.invalidMessage"
				class="lc__username"
				>
					<p class="username-info">The organization suffix ({{ organizationSuffix }}) will be automatically attached to the username.</p>
					<div @click="focusUsernameField" id="username-editable-content" class="form-control">
						<span id="username-prefix" class="editable" @keydown="handleLCKeypress" @focus="setFocusStyle" @blur="removeUsernameFocus" @input="setNewUsername" contenteditable="true" v-html="usernamePrefix.value"></span>
						<span id="username-postfix" class="non-editable">{{ organizationSuffix.trim() }}</span>
					</div>
				<!-- <b-input-group>
					<b-input-group :append="organizationSuffix">
						<b-form-input placeholder="User Name" v-model="usernamePrefix.value"
						:state="usernamePrefix.status"
						@input="usernamePrefix.resetStatus()"
						></b-form-input>
					</b-input-group>
				</b-input-group> -->
			</b-form-group>

			<b-form-group label="Set New Password"
			:state="user.password.status"
			:invalid-feedback="user.password.invalidMessage"
			>
			<b-input-group>
				<b-form-input
				v-model="user.password.value"
				id="password"
				:strength="passwordStrength"
				:type="passwordFieldType"
				@input="updatePasswordStrength"
				autocomplete="off"
				/>
				<b-input-group-append>
					<b-button variant="secondary" @click="switchPasswordVisibility()">show/hide</b-button>
				</b-input-group-append>
			</b-input-group>
		</b-form-group>

		<b-form-group label="First Name"
		:state="user.firstName.status"
		:invalid-feedback="user.firstName.invalidMessage"
		>
		<b-form-input placeholder="First Name" v-model="user.firstName.value"
		:state="user.firstName.status"
		@input="user.firstName.resetStatus()"
		></b-form-input>
	</b-form-group>


	<b-form-group label="Last Name"
	:state="user.lastName.status"
	:invalid-feedback="user.lastName.invalidMessage"
	>
	<b-form-input placeholder="Last Name" v-model="user.lastName.value"
	:state="user.lastName.status"
	@input="user.lastName.resetStatus()"
	></b-form-input>
</b-form-group>

<b-form-group label="Title"
:state="user.title.status"
:invalid-feedback="user.title.invalidMessage"
>
<b-form-input placeholder="Title" v-model="user.title.value"
:state="user.title.status"
@input="user.title.resetStatus()"
></b-form-input>
</b-form-group>

<b-form-group label="Email Address"
:state="user.email.status"
:invalid-feedback="user.email.invalidMessage"
>
<b-form-input type="email" placeholder="Email Address" v-model="user.email.value"
:state="user.email.status"
@input="user.email.resetStatus()"
></b-form-input>
</b-form-group>
<!-- 			<b-form-group  label="Is Email Address Confirmed?"
				:state="user.isEmailConfirmed.status"
				:invalid-feedback="user.isEmailConfirmed.invalidMessage"
				id="fg-is-email-confirmed"
				class="fg-is-email-confirmed"
				v-if="canSetApproval()"
			>
				<b-form-radio-group
					id="rg-is-email-confirmed"
					v-model="user.isEmailConfirmed.value"
					:options="User.getEmailConfirmedOptions"
					@change="user.isEmailConfirmed.resetStatus()"
					:state="user.isEmailConfirmed.status"
				>
				</b-form-radio-group>
			</b-form-group> -->


			<b-form-group label="Primary Phone"
			:state="user.phone.status"
			:invalid-feedback="user.phone.invalidMessage"
			>
			<b-input id="mySettingsUserPhone" type="tel" v-mask="'#-###-###-####'" masked="true" @focus="onPhoneFocus" @blur="onPhoneBlur" v-model="user.phone.value" placeholder="1-###-###-####"/>

		</b-form-group>


		<b-form-group label="Alternate Phone"
		:state="user.altPhone.status"
		:invalid-feedback="user.altPhone.invalidMessage"
		>
		<b-input id="mySettingsUserAltPhone" type="tel" v-mask="'#-###-###-####'" masked="true" @focus="onAltPhoneFocus" @blur="onAltPhoneBlur" v-model="user.altPhone.value" placeholder="1-###-###-####"/>
	</b-form-group>
</b-col>
<b-col lg="4">

	<b-form-group  label="Is Account Active?"
	:state="user.isActive.status"
	:invalid-feedback="user.isActive.invalidMessage"
	id="fg-is-active"
	class="fg-is-active"
	v-if="canSetApproval()"
	>
	<b-form-radio-group
	id="rg-is-active"
	v-model="user.isActive.value"
	:options="User.getActiveOptions"
	@change="user.isActive.resetStatus()"
	:state="user.isActive.status"
	>
</b-form-radio-group>
</b-form-group>

<b-form-group  label="Administrator Approval"
:state="user.isApproved.status"
:invalid-feedback="user.isApproved.invalidMessage"
id="fg-is-approved"
class="fg-is-approved"
v-if="canSetApproval()"
>
<b-form-radio-group
id="rg-is-approved"
v-model="user.isApproved.value"
:options="User.getApprovedOptions"
@change="user.isApproved.resetStatus()"
:state="user.isApproved.status"
>
</b-form-radio-group>
</b-form-group>


<b-form-group
id="ig-supervisor"
label="Supervisor"
label-for="input-lcr-supervisor"
description=""
:state="selectSupervisor.status"
:invalid-feedback="selectSupervisor.invalidMessage"
>
<div v-if="supervisor" class="contact">
	<div class="contact__name">{{supervisor.firstName}} {{supervisor.lastName}}</div>
	<div class="contact__organization">{{supervisor.organizationName}}</div>
	<div class="contact__phone">{{supervisor.phone}}</div>
	<b-button variant="light-blue" type="button" class="btn-sm mt-1 mb-2" @click="onRemoveSupervisor()">Remove</b-button>
</div>
<autocomplete
:search="SearchSupervisor"
:get-result-value="SearchSupervisorValue"
@submit="HandleSelectSupervisor"
placeholder="Start typing to select Supervisor"
aria-label="Start typing to select Supervisor"
ref="searchSupervisor"
auto-select
>
<template v-slot:result=" {result, props } ">
	<li v-bind="props" class="autocomplete-result supervisor-result">
		<div class="contact-name">{{result.firstName}} {{result.lastName}}</div>
		<div class="contact-organization">{{result.organizationName}}</div>
		<div class="contact-phone">{{result.phone}}</div>
	</li>
</template>
</autocomplete>
</b-form-group>

<b-form-group
id="ig-alternate"
label="Alternate Contact"
label-for="input-lcr-alternate"
description=""
:state="selectAlternate.status"
:invalid-feedback="selectAlternate.invalidMessage"
>
<div v-if="alternateContact" class="contact">
	<div class="contact__name">{{alternateContact.firstName}} {{alternateContact.lastName}}</div>
	<div class="contact__organization">{{alternateContact.organizationName}}</div>
	<div class="contact__phone">{{alternateContact.phone}}</div>
	<b-button variant="light-blue" type="button" class="btn-sm mt-1 mb-2" @click="onRemoveAlternateContact()">Remove</b-button>
</div>
<autocomplete
:search="SearchAlternate"
:get-result-value="SearchAlternateValue"
@submit="HandleSelectAlternate"
placeholder="Start typing to select Alternate Contact"
aria-label="Start typing to select Alternate Contact"
ref="searchAlternate"
auto-select
>
<template v-slot:result=" {result, props } ">
	<li v-bind="props" class="autocomplete-result alternate-result">
		<div class="contact-name">{{result.firstName}} {{result.lastName}}</div>
		<div class="contact-organization">{{result.organizationName}}</div>
		<div class="contact-phone">{{result.phone}}</div>
	</li>
</template>
</autocomplete>
</b-form-group>

<b-form-group  v-if="false" label="Is user away?"
:state="user.isAway.status"
:invalid-feedback="user.isAway.invalidMessage"
id="fg-is-away"
class="fg-is-away"
>
<b-form-radio-group
id="rg-is-away"
v-model="user.isAway.value"
:options="User.getYesNoUserAwayOptions"
@change="user.isAway.resetStatus()"
:state="user.isAway.status"
>
</b-form-radio-group>
</b-form-group>

<b-form-group label="Lane Closures Role" v-if="canSetRoles()">
	<b-form-checkbox-group
	v-model="user.roles.value"
	name="roles"
	stacked
	>
	<b-form-checkbox v-if="canAssignRole(User.getRoleOptions[0].id)" :value="{id: User.getRoleOptions[0].id}" :checked="checkRole(User.getRoleOptions[0].id)"><span>{{User.getRoleOptions[0].name}}</span></b-form-checkbox>
	<b-form-checkbox v-if="canAssignRole(User.getRoleOptions[1].id)" :value="{id: User.getRoleOptions[1].id}" :checked="checkRole(User.getRoleOptions[1].id)"><span>{{User.getRoleOptions[1].name}}</span></b-form-checkbox>
	<b-form-checkbox v-if="canAssignRole(User.getRoleOptions[2].id)" :value="{id: User.getRoleOptions[2].id}" :checked="checkRole(User.getRoleOptions[2].id)"><span>{{User.getRoleOptions[2].name}}</span></b-form-checkbox>
	<b-form-checkbox v-if="canAssignRole(User.getRoleOptions[3].id)" :value="{id: User.getRoleOptions[3].id}" :checked="checkRole(User.getRoleOptions[3].id)"><span>{{User.getRoleOptions[3].name}}</span></b-form-checkbox>
	<b-form-checkbox v-if="canAssignRole(User.getRoleOptions[4].id)" :value="{id: User.getRoleOptions[4].id}" :checked="checkRole(User.getRoleOptions[4].id)"><span>{{User.getRoleOptions[4].name}}</span></b-form-checkbox>
	<b-form-checkbox v-if="canAssignRole(User.getRoleOptions[5].id)" :value="{id: User.getRoleOptions[5].id}" :checked="checkRole(User.getRoleOptions[5].id)"><span>{{User.getRoleOptions[5].name}}</span></b-form-checkbox>
	<b-form-checkbox v-if="canAssignRole(User.getRoleOptions[6].id)" :value="{id: User.getRoleOptions[6].id}" :checked="checkRole(User.getRoleOptions[6].id)"><span>{{User.getRoleOptions[6].name}}</span></b-form-checkbox>
</b-form-checkbox-group>
</b-form-group>

<b-form-group label="Lane Closures Role" v-if="!canSetRoles()">
	<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[0].id)"><span>{{User.getRoleOptions[0].name}}</span></div>
	<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[1].id)"><span>{{User.getRoleOptions[1].name}}</span></div>
	<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[2].id)"><span>{{User.getRoleOptions[2].name}}</span></div>
	<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[3].id)"><span>{{User.getRoleOptions[3].name}}</span></div>
	<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[4].id)"><span>{{User.getRoleOptions[4].name}}</span></div>
	<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[5].id)"><span>{{User.getRoleOptions[5].name}}</span></div>
	<div class="lcr-summary__value" sm="12" v-if="hasRole(User.getRoleOptions[6].id)"><span>{{User.getRoleOptions[6].name}}</span></div>
</b-form-group>
</b-col>
</b-row>
<b-row>
	<b-col class="mt-3">
		<b-button variant="primary" type="button" @click="onSubmit">Save <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button>
	</b-col>
</b-row>

<b-modal centered v-model="showRequiredFieldModal" type="info" @confirm="showRequiredFieldModal = false">
	<template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
	<ul>
		<li v-for="requiredField in modalRequiredFieldList" v-bind:key="'reqfield'+requiredField">{{$t(requiredField)}}</li>
	</ul>
	<template slot="footer">
		<b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalRequiredFieldClose" />
	</template>
</b-modal>

<!-- leaving page -->
<b-modal centered id="unsaved-changes-error-modal" title="Unsaved Changes" size="lg" v-model="showUnsavedChangesModal" @ok="modalOnCancel()">
	<p class="is-size-6">{{ $t('messages.unsavedChanges') }}</p>
	<template v-slot:modal-footer="{ ok }">
		<!-- <b-button variant="primary"  type="button" @click="modalOnSave">{{$t('labels.save')}} <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button> -->
		<b-button variant="danger" type="button" @click="modalOnLeave">{{$t('labels.leaveAnyway')}}</b-button>
		<b-button variant="secondary"  type="button" @click="modalOnCancel">{{$t('labels.stay')}}</b-button>
	</template>
</b-modal>

</b-form>
</b-container>
<Spinner v-else />
</template>


<script>
import User from '../models/User';
import Autocomplete from '@trevoreyre/autocomplete-vue'
import BootstrapField from '../utility/BootstrapField';
import ErrorHandler from '../utility/ErrorHandler';
// import { VuePassword } from '../components/vue-password'
import Format from '../utility/Format';
import { VueSelectGrouped } from '../components/vue-select-grouped';

import Spinner from "./../components/Spinner.vue"

import Vue from 'vue'

export default {
	name: 'MySettings',
	docTitle: "Account - Lane Closures",

	components: {
		Autocomplete,
	// VuePassword,
	VueSelectGrouped,
	Spinner,
},
data() {
	return {
		User,
		Format,
		editedUsername: 'INITIAL__DATA',
		id:null,
		user: null,
		saving:false,
		organizations:[],
		onSubmitPromiseDeferred: {
			resolve:null,
			reject:null
		},
		showUnsavedChangesModal:false,
		lineIndexError:null,
		isButtonDisabled: false,
		saveState:null,
		modalRequiredFieldList: [],
		selectSupervisor:new BootstrapField({
			value: null,
		}),
		selectAlternate:new BootstrapField({
			value: null,
		}),
		selectAway:new BootstrapField({
			value: null,
		}),
		loaded: false,
		showRequiredFieldModal: false,
		supervisor: null,
		alternateContact: null,
		awayInfo: null,
		refSearchSupervisor: null,
		refSearchAlternate: null,
		refSearchAway: null,
		show: true,
		showNewOrganizationModal: false,
		organizationInfo:null,
		passwordStrength:0,
		passwordFieldType: "password",
		confirmPasswordStrength:0,
		usernamePrefix:new BootstrapField({
			value: null, required:true})
	}
},
mounted() {
	this.waitForUserId();
},
computed: {
	organizationSuffix: function() {
		if (this.user) {
			if (this.organizationInfo) {
				if (this.organizationInfo.domain) {
					return this.organizationInfo.domain;
				}
			}
		}
		return "";
	}
},

watch: {
	'user.organizationId.value':function() {
		this.calculateUserName();
	},
	'usernamePrefix.value':function() {
		this.calculateUserName();
	},
	'user.phone.value':function() {
	}
},

methods: {
	onPhoneFocus:function() {
		if (this.user.phone.value == null || this.user.phone.value == "") {
			setTimeout(function(){
			      document.getElementById('mySettingsUserPhone').value = "1-";
			      document.getElementById('mySettingsUserPhone').selectionStart = document.getElementById('mySettingsUserPhone').value.length;
			      document.getElementById('mySettingsUserPhone').selectionEnd = document.getElementById('mySettingsUserPhone').value.length;
			    },1);  // call the function after 50ms
		}
	},
	onPhoneBlur:function() {
		if (this.user.phone.value == "1-" || document.getElementById('mySettingsUserPhone').value == "1-") {
			this.user.phone.value = null;
			setTimeout(function(){
			    document.getElementById('mySettingsUserPhone').value = null;
			},1);  // call the function after 50ms
		}
	},
	onAltPhoneFocus:function() {
		if (this.user.altPhone.value == null || this.user.altPhone.value == "") {
				// this.user.altPhone.value = "1-";
			setTimeout(function(){
			      document.getElementById('mySettingsUserAltPhone').value = "1-";
			      document.getElementById('mySettingsUserAltPhone').selectionStart = document.getElementById('mySettingsUserAltPhone').value.length;
			      document.getElementById('mySettingsUserAltPhone').selectionEnd = document.getElementById('mySettingsUserAltPhone').value.length;
			    },1);  // call the function after 50ms

		}
	},
	onAltPhoneBlur:function() {
		if (this.user.altPhone.value == "1-" || document.getElementById('mySettingsUserAltPhone').value == "1-") {
			this.user.altPhone.value = null;
			setTimeout(function(){
			    document.getElementById('mySettingsUserAltPhone').value = null;
			},1);  // call the function after 50ms
		}
	},

	handleLCKeypress: function(event) {
		if (event.key == " " || event.key == 'PageUp' || event.key == 'PageDown') {
			event.preventDefault();
		}
	},
	setUsernameValidateStyle() {
		document.getElementById('username-editable-content').classList.remove('is-invalid');
		document.getElementsByClassName('lc__username')[0].getElementsByClassName('invalid-feedback')[0].classList.remove('d-block');
		if(this.usernamePrefix.value == '') {
			document.getElementById('username-editable-content').classList.add('is-invalid');
		}
	},
	focusUsernameField(e) {
		document.getElementById('username-prefix').focus();
	},
	setFocusStyle() {
		requestAnimationFrame(() => document.execCommand('selectAll'));
		document.getElementById('username-editable-content').classList.add('focus');
	},
	setNewUsername(e) {
		this.editedUsername = e.target.innerText;
		if (e.target.innerText == "" && e.target.innerHTML != "")  {
			this.editedUsername = e.target.innerHTML;
		}

	},
	removeUsernameFocus() {
		if(this.editedUsername != 'INITIAL__DATA' ) {
			this.usernamePrefix.value = this.editedUsername.trim();
		} else {
			this.editedUsername = this.usernamePrefix.value;
		}
		this.setUsernameValidateStyle();
		document.getElementById('username-editable-content').classList.remove('focus');
	},
	switchPasswordVisibility() {
		this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
	},
	checkRole: function(id) {
		let i = 0;
		if (this.user) {
			if (this.user.roles) {
				for (i = 0; i < this.user.roles.length; i++) {
					if (this.user.roles[i].id == id) {
						this.user.roles.splice(i, 1)
						return true;
					}
					return false;
				}
			}
		}
		return false;
	},
	hasRole: function(id) {
		let i = 0;
		if (this.user) {
			if (this.user.roles) {
				for (i = 0; i < this.user.roles.value.length; i++) {
					if (this.user.roles.value[i].id == id) {
						return true;
					}
					return false;
				}
			}
		}
		return false;
	},



	canAssignRole: function(id) {
		if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
			return true;
		} else {
			if (this.$store.getters.userHasRole('agency_admin')) {
				if (id == "agency_user" || id == "agency_admin" || id == "agency_supervisor") {
					return true;
				}
			}
		}
		return false;
	},

	canEditUser() {
		if (this.$store.getters.userId() == this.id) {
			return true;
		}
		return false;
	},
	canSetApproval() {
		// can't set your own approvals.
		return false;
	},
	canSetRoles() {
		// Can't set your own roles.
		return false;
	},


	toggleEmailNotification(item) {
		if (item == "toggleEmail") {
			if (this.user.notifyEmailAllLcr.value == 1 && this.user.notifyEmailMyLcr.value == 1) {
				this.user.notifyEmailAllLcr.value = 0;
				this.user.notifyEmailMyLcr.value = 0;
			} else {
				this.user.notifyEmailAllLcr.value = 1;
				this.user.notifyEmailMyLcr.value = 1;
			}
		}
		if (item == "toggleNotifyEmailAllLcr") {
			this.user.notifyEmailAllLcr.value = ! this.user.notifyEmailAllLcr.value;
		}
		if (item == "toggleNotifyEmailMyLcr") {
			this.user.notifyEmailMyLcr.value = ! this.user.notifyEmailMyLcr.value;
		}
	},
	toggleAppNotification(item) {
		if (item == "toggleApp") {
			if (this.user.notifyAppAllLcr.value == 1 && this.user.notifyAppMyLcr.value == 1) {
				this.user.notifyAppAllLcr.value = 0;
				this.user.notifyAppMyLcr.value = 0;
			} else {
				this.user.notifyAppAllLcr.value = 1;
				this.user.notifyAppMyLcr.value = 1;
			}
		}
		if (item == "toggleNotifyAppAllLcr") {
			this.user.notifyAppAllLcr.value = ! this.user.notifyAppAllLcr.value;
		}
		if (item == "toggleNotifyAppMyLcr") {
			this.user.notifyAppMyLcr.value = ! this.user.notifyAppMyLcr.value;
		}
	},
	toggleBrowserNotification(item) {
		if (item == "toggleBrowser") {
			if (this.user.notifyBrowserAllLcr.value == 1 && this.user.notifyBrowserMyLcr.value == 1) {
				this.user.notifyBrowserAllLcr.value = 0;
				this.user.notifyBrowserMyLcr.value = 0;
			} else {
				this.user.notifyBrowserAllLcr.value = 1;
				this.user.notifyBrowserMyLcr.value = 1;
			}
		}
		if (item == "toggleNotifyBrowserAllLcr") {
			this.user.notifyBrowserAllLcr.value = ! this.user.notifyBrowserAllLcr.value;
		}
		if (item == "toggleNotifyBrowserMyLcr") {
			this.user.notifyBrowserMyLcr.value = ! this.user.notifyBrowserMyLcr.value;
		}
	},
	toggleSoundNotification(item) {
		if (item == "toggleSound") {
			if (this.user.notifySoundAllLcr.value == 1 && this.user.notifySoundMyLcr.value == 1) {
				this.user.notifySoundAllLcr.value = 0;
				this.user.notifySoundMyLcr.value = 0;
			} else {
				this.user.notifySoundAllLcr.value = 1;
				this.user.notifySoundMyLcr.value = 1;
			}
		}
		if (item == "toggleNotifySoundAllLcr") {
			this.user.notifySoundAllLcr.value = ! this.user.notifySoundAllLcr.value;
		}
		if (item == "toggleNotifySoundMyLcr") {
			this.user.notifySoundMyLcr.value = ! this.user.notifySoundMyLcr.value;
		}
	},
	setOrganization(val) {
		let x = 0;
		if (typeof val == "object") {
			for (x = 0; x < this.organizations.length; x++) {
				if (val) {
					if (val.id == 	this.organizations[x].id) {

						this.organizationInfo = this.organizations[x];
					}
				}
			}
		} else {
			for (x = 0; x < this.organizations.length; x++) {
				if (val == 	this.organizations[x].id) {
					this.organizationInfo = this.organizations[x];
				}
			}
		}
	},
	getLevelClassName(level) {
		return "level-"+level;
	},
	getFlatTree(option) {
		if (option) {
			if (option.namePath) {
				return Format.pipesToFlatTree(option.namePath);
			} else {
				return option.name;
			}
		}
		return null;
	},

	// required fields notifying modal
	modalRequiredFieldClose(){
		this.showRequiredFieldModal = false;
	},

	calculateUserName() {
		if (this.user && this.user.organizationId.value) {
			this.user.username.value = this.usernamePrefix.value + this.user.organizationId.value.domain;
		} else {
			this.user.username.value = null;
		}
		// TODO: confirm that user name is not taken.
	},
	showErrors(errors){
		this.submissionStatus = 'submission-error';
		this.modalRequiredFieldList = [];
		for(let field in errors) {
			this.modalRequiredFieldList.push(errors[field]);
		}
		this.showRequiredFieldModal = true;
	},

	removeAlternateContact(index) {
		this.alternateContact.splice(index, 1);
	},


	SearchSupervisor(input) {
		return new Promise((resolve, reject) => {
			if (input.length < 1) {
				return resolve([])
			}
			Vue.prototype.$http.get(this.$store.state.apiUrl + '/organization/users/assignable/?q='+encodeURI(input))
			.then(resp => {
				resolve(resp.data)
			})
			.catch(error => {
				if (!ErrorHandler.HasLoginErrorCode(error)) {
					this.showErrors(error.response.data.fields);
				} else {
					ErrorHandler.RedirectToLogin();
				}
				reject(error)
			})
		})
	},
	SearchSupervisorValue(result) {
		return result.firstName
	},
		// Addeds a transaction line with contact attached.
		HandleSelectSupervisor(selected) {
			if (selected) {

				this.supervisor = selected;
				this.user.supervisorUserId.value = parseInt(selected.userId);
				this.$refs.searchSupervisor.value = "";
				/*
				if (this.user.id == selected.userId) {
					this.$refs.searchSupervisor.value = "";
				} else {
					this.supervisor = selected;
					this.user.supervisorUserId.value = parseInt(selected.userId);
					this.$refs.searchSupervisor.value = "";
				}
				*/
			}
		},



		SearchAlternate(input) {
			return new Promise((resolve, reject) => {
				if (input.length < 1) {
					return resolve([])
				}
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/organization/users/assignable/?q='+encodeURI(input))
				.then(resp => {
					resolve(resp.data)
				})
				.catch(error => {
					reject(error)
				})
			})
		},
		SearchAlternateValue(result) {
			return result.firstName
		},
		// Addeds a transaction line with contact attached.
		HandleSelectAlternate(selected) {
			if (selected) {
				if (this.user.id == selected.userId) {
					this.$refs.searchAlternate.value = "";
				} else {
					this.alternateContact = selected;
					this.user.alternateUserId = parseInt(selected.userId);
					this.$refs.searchAlternate.value = "";
				}
			}
		},


		onSubmit(evt) {
			evt.preventDefault()
			let that = this;
			if (that.editedUsername.trim() != "INITIAL__DATA") {
				that.user.username.value = that.editedUsername.trim()+that.organizationSuffix;
			}
			that.setUsernameValidateStyle();
			if (this.validateFields()) {
				return new Promise(function(resolve,reject){
					that.onSubmitPromiseDeferred.resolve = resolve;
					that.onSubmitPromiseDeferred.reject = reject;
					that.Save(that.user);
				});
			}
		},

		onRemoveSupervisor() {
			this.supervisor = null;
			this.user.supervisorUserId = null;
		},
		onRemoveAlternateContact() {
			this.alternateContact = null;
			this.user.alternateUserId = null;
		},
		onReset(evt) {
			evt.preventDefault()
			// Trick to reset/clear native browser form validation state
			this.show = false
			this.$nextTick(() => {
				this.show = true
			})
		},
		Save(t) {
			this.saving = true;

			if (t instanceof User) {
				Vue.prototype.$http({
					method: 'put',
					url: `${this.$store.state.apiUrl}/user/${t.id}?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: t.getRawValue()
				}).then(() => {
					this.saveState = 'success';
					this.submissionStatus = 'submission-success';
					this.SaveSuccess();
					this.onSubmitPromiseDeferred.resolve();
					this.$refs.refAttachments.autoSave();

				}).catch(error => {
					this.saveState = 'fail';
					if (error) {
						if (error.response) {
							if (!ErrorHandler.HasLoginErrorCode(error)) {
									// this.laneClosureRequest.SetErrors(error.response.data);
									this.showErrors(error.response.data.fields);
								} else {
									ErrorHandler.RedirectToLogin();
								}
							}
						}
						this.onSubmitPromiseDeferred.reject();
					}).finally(() => {
						this.isButtonDisabled = false;
						this.saving = false;
					});
				}
			},
			SaveSuccess() {
				let that = this;
				this.user.saveChanges();
				this.$store.dispatch('aboutMe').then(function() {
					let lastPage = that.$routerStore.getters['getLastListPage'];
					// console.log("lastPage:"+lastPage);
					if (lastPage == null) {
						that.$router.push("/lane-closure-request-list?r="+Math.round(Math.random() * Math.pow(10, 6)));
					} else {
						that.$router.push(lastPage.path);
					}
				});


			},

			validateFields() {

				let flag = this.user.validate();
				return flag;
			},


			LoadUser(id = this.id) {
				this.loaded = false;
				// Remove any messages being displayed.
				this.submissionStatus = null;
				this.$store.dispatch('organizationList/loadAssignable', this.$store.getters['organizationList/getParams'])
				.then(() => {
					this.organizations = [];
					let records = this.$store.getters['organizationList/getRecords'];
					if ( records ) {
						records.forEach( item => {
							this.organizations.push(item);
						})
					}

					if (id && Format.TryParseInt(id) > 0) {
						this.GetUser(id);
					}
					else {
						if (this.data) {
							this.user = new User(this.data);
							this.user.saveChanges();
						}
					}


				})
				.catch( error => console.log('error', error) ); // eslint-disable-line
			},
			// Loads user data into the component based on provided id.
			GetUser(id) {
				if (Format.TryParseInt(id)) {
					this.loaded = false;
					Vue.prototype.$http.get(this.$store.state.apiUrl + "/user/" + id + "/edit?r=" + Math.round(Math.random() * Math.pow(10, 6))).then(response => {
						this.user = new User(response.data);
						this.setOrganization(this.user.organizationId.value);

						this.supervisor = response.data.supervisor;
						this.alternateContact = response.data.alternateContact;

						// Set the username prefix...
						let usernameParts = this.user.username.getValue().split("@");
						this.usernamePrefix.value = usernameParts[0];
						this.$nextTick(() => {
							this.GetOrganizations();
						})
					}).catch(error => {
						if (!ErrorHandler.HasLoginErrorCode(error)) {
							if (error.response && error.response.data) {
								this.loaded = false;
								this.transactionStatus = 'load-error';
								this.errorDetails = error.response.data;
							}
						} else {
							ErrorHandler.RedirectToLogin();
						}
					});
				}
			},

			closeNewOrganizationModal() {
				this.showNewOrganizationModal = false;
			},
			openNewOrganizationModal() {
				this.showNewOrganizationModal = true;
			},
			GetOrganizations() {
				this.$store.dispatch('organizationList/loadEditable', {keywords:null})
				.then(() => {
					this.organizations = [];
					let records = this.$store.getters['organizationList/getRecords'];
					if ( records ) {
						records.forEach( item => {
							this.organizations.push(item);
							if (item.id == this.user.organizationId.value) {
								this.user.organizationId.value = item;
							}
						})
					}
					if (this.user.organizationId.value == null) {
						this.user.organizationId.value = this.organizations[0];
					}
					this.loaded = true;
				})
				.catch( error => console.log('error', error) ); // eslint-disable-line
			},

		updatePasswordStrength(password) {
			let has_number    = /\d/.test(password);
			let has_lowercase = /[a-z]/.test(password);
			let has_uppercase = /[A-Z]/.test(password);
			let has_special   = /[!@#\$%\^\&*\)\(+=._-]/.test(password);  // eslint-disable-line
			let strength = 0;
			if (has_number) {
				strength++;
			}
			if (has_lowercase) {
				strength++;
			}
			if (has_uppercase) {
				strength++;
			}
			if (has_special) {
				strength++;
			}
			if (password.length < 8) {
				strength = 0;
			}
			this.passwordStrength = strength;
		},

		waitForUserId() {
			this.id = this.$store.getters.userId();

			if (!this.id) {
				window.setTimeout(this.waitForUserId, 100);
			} else {
				this.LoadUser();
			}
		},
		modalOnCancel() {
			this.showUnsavedChangesModal = false;
			if (this.$store.getters.logoutRequested) {
				this.$store.commit('logoutRequested', false);
			}
		},
	}, // end of methods();

	beforeRouteEnter(to, from, next) {
		next(vm => {
			Vue.prototype.$bus.$emit("map:clear", 1);
			Vue.prototype.$bus.$emit("map:toggle", 0);
		});
	},

	beforeRouteLeave(to, from, next) {
		if (this.loaded && this.user.hasChanges()) {
			if (this.overrideUnsavedChanges) {
				next(true);
			} else {
				this.showUnsavedChangesModal = true;
				this.modalOnSave = (function() {
					this.onSubmit().then(() => {
						next(true);
					}).catch(() => {
						next(false);
					});
				}).bind(this);

				this.modalOnLeave = (function() {
					this.showUnsavedChangesModal = false;
					next(true);
				}).bind(this);

				next(false);
			}
		}
		else {
			next(true);
		}
	},

}
</script>
<i18n>
{
	"en-CA": {

	}
}

</i18n>